namespace GeniuzPOS.Purchase {
    export interface UpdateCancelAndUseFgRequest {
        SysDocNo?: string;
        CancelFg?: number;
        UseFg?: number;
    }
}
